(function () {'use strict';}());
angular.module("app").directive('meter', function($document,$timeout, $interval) {
    return {
      restrict: 'A',
      replace:true,
      templateUrl: 'views/meter.html?version=1.0',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        $timeout(function(){
          initializeScores();
          $timeout(activate,element.closest("li").index() * 750);
        },0);

        
        $scope.$on("assessmentChange",onAssessmentUpdate);

        $scope.getLabel = function(){
          switch($scope.score)
          {
            case 0:
              return "skipped";
            case 2:
              return "low";
            case 4:
              return "moderate";
            case 6:
              return "high";
            default:
              return  "";
          }
        };

        function onAssessmentUpdate()
        {
          initializeScores();
          $timeout(activate,element.closest("li").index() * 750);
        }

        function initializeScores()
        {
            var response = parseInt($scope.question.userResponse) || 0;
            if($scope.question.userResponse === null) response = null;
            
            var result = $scope.getAdjustedScore($scope.question,response);
            $scope.active = false;
            $scope.self = $scope;

            $scope.pos1Active = false;
            $scope.pos2Active = false;
            $scope.pos3Active = false;
            $scope.pos4Active = false;
            $scope.pos5Active = false;
            $scope.pos6Active = false;

            $scope.label = result.label;

            if($scope.question.userResponse === null) $scope.score = 0;
            else if(result.value === 0) $scope.score = 2;
            else if(result.value === 1) $scope.score = 4;
            else $scope.score = 6;
        }

        var promise;

        function activate(){
          
        	var increment = 0;

          if($scope.score === 0) return;
          $interval.cancel(promise);
        	promise = $interval(function(){
        		increment ++;
        		$scope['pos'+increment+'Active'] = true;
        		if(increment === $scope.score) $interval.cancel(promise);
        	},150);
        }
      }  
    };
  });